<!--
  - Copyright (c) 2021 brightlamp
  -->

<template>
    <v-container>
        <v-toolbar dense class="mb-2 indigo white--text" flat>
            <v-toolbar-title>Identifying Data</v-toolbar-title>
        </v-toolbar>
            <v-row dense>
                <v-col :cols="12">
                    <ValidationProvider
                        mode="aggressive"
                        rules="requiredPatientId"
                        :debounce="300"
                        v-slot="{ errors }">
                        <v-text-field
                            v-model="mrn"
                            label="Patient ID *"
                            :error-messages=errors[0]>
                        </v-text-field>
                    </ValidationProvider>
                </v-col>
                <v-col :cols="12">
                    <v-text-field
                        v-model="groupId"
                        label="Group ID">
                    </v-text-field>
                </v-col>
                <v-col :cols="12">
                    <v-text-field
                        v-model="name"
                        label="Full Name">
                    </v-text-field>
                </v-col>
                <v-col :cols="12">
                    <ValidationProvider
                        mode="aggressive"
                        rules="requiredAge|ageNumeric"
                        :debounce="300"
                        v-slot="{ errors }">
                        <v-text-field
                            v-model="ageDob"
                            label="Age *"
                            persistent-hint
                            hint="The age will increment each year up to 130."
                            :error-messages=errors[0]>
                        </v-text-field>
                    </ValidationProvider>
                </v-col>
                <v-col :cols="12">
                    <ValidationProvider
                        mode="aggressive"
                        rules="requiredSex"
                        :debounce="300"
                        v-slot="{ errors }">
                        <v-select
                            v-model="sex"
                            :items="genders"
                            label="Sex *"
                            persistent-hint
                            hint="Select the patient's sex."
                            :error-messages=errors[0]>
                        </v-select>
                    </ValidationProvider>
                </v-col>
            </v-row>
    </v-container>
</template>

<script>
    import { mapState } from 'vuex'
    import { ValidationProvider, extend } from 'vee-validate';
    import { numeric, required } from 'vee-validate/dist/rules';
    import { returnAge } from '@/store/tests'

    extend('requiredPatientId',
    {
        ...required,
        message: 'No patient ID specified.'
    });
    extend('requiredAge',
    {
        ...required,
        message: 'No age specified.'
    });
    extend('ageNumeric',
    {
        ...numeric,
        message: 'The age needs to be a number.'
    });
    extend('requiredSex',
    {
        ...required,
        message: 'No sex specified.'
    });

    export default
    {
        name: 'patient-data-bio-info',
        components:
        {
            ValidationProvider
        },
        data: function ()
        {
            return {
                genders:
                [
                    'Male',
                    'Female'
                ]
            }
        },
        computed:
        {
            ...mapState('tests',
            {
                patientDataToMutate: state => state.patientDataToMutate
            }),
            mrn:
            {
                get: function ()
                {
                    return this.patientDataToMutate.mrn
                },
                set: function (newValue)
                {
                    this.patientDataToMutate.mrn = newValue
                }
            },
            groupId:
            {
                get: function ()
                {
                    return this.patientDataToMutate.groupId
                },
                set: function (newValue)
                {
                    this.patientDataToMutate.groupId = newValue
                }
            },
            name:
            {
                get: function ()
                {
                    return this.patientDataToMutate.name
                },
                set: function (newValue)
                {
                    this.patientDataToMutate.name = newValue
                }
            },
            ageDob:
            {
                get: function ()
                {
                    if (!this.patientDataToMutate.dob)
                    {
                        return null
                    }
                    return returnAge(this.patientDataToMutate.dob)
                },
                set: function (newValue)
                {
                    if ('' === newValue || isNaN(newValue) || newValue > 131)
                    {
                        this.patientDataToMutate.dob = null
                    }
                    else
                    {
                        this.patientDataToMutate.dob = new Date(new Date().getFullYear() - newValue, new Date().getMonth(), new Date().getDate())
                    }
                }
            },
            sex:
            {
                get: function ()
                {
                    return this.patientDataToMutate.gender ? 'MALE' === this.patientDataToMutate.gender ? 'Male' : 'Female' : ''
                },
                set: function (newValue)
                {
                    this.patientDataToMutate.gender = 'Male' === newValue ? 'MALE' : 'FEMALE'
                }
            }
        }
    };
</script>

<style scoped>
</style>